import React from "react";
import * as tableStyles from "../styles/table.module.scss";
import { WeightedTable, WeightedTableColumnLayout } from "./weighted-table";
import { classArr } from "../helper/style-helper";

export interface VelavuRoundTableProps {
	style?: React.CSSProperties;
	className?: string;
	children?: React.ReactNode;
	layout?: WeightedTableColumnLayout[];
}

export function VelavuRoundTable(props: VelavuRoundTableProps) {
	return (
		<WeightedTable
			style={props.style}
			className={classArr(tableStyles.roundTable, props.className)}
			layout={props.layout}
		>
			{props.children}
		</WeightedTable>
	);
}
